module.exports = __webpack_public_path__ + "img/google-logo.be77e5b6.png";